'use client'

import { useEffect } from 'react'

export function DynamicFont({ fontFamily }: { fontFamily: string }) {
  useEffect(() => {
    // Preconnect so the font CSS + the font binary (on a second origin) skip a
    // connection-setup round trip — meaningful on slow mobile networks.
    const preconnectCss = document.createElement('link')
    preconnectCss.rel = 'preconnect'
    preconnectCss.href = 'https://fonts.googleapis.com'

    const preconnectFont = document.createElement('link')
    preconnectFont.rel = 'preconnect'
    preconnectFont.href = 'https://fonts.gstatic.com'
    preconnectFont.crossOrigin = 'anonymous'

    const link = document.createElement('link')
    // `display=swap` → render fallback text immediately and swap when the font
    // arrives, instead of the default FOIT (invisible text) that leaves the page
    // looking blank/broken on slow Android connections.
    link.href = `https://fonts.googleapis.com/css?family=${fontFamily.replace(/ /g, '+')}&display=swap`
    link.rel = 'stylesheet'

    document.head.appendChild(preconnectCss)
    document.head.appendChild(preconnectFont)
    document.head.appendChild(link)

    return () => {
      document.head.removeChild(preconnectCss)
      document.head.removeChild(preconnectFont)
      document.head.removeChild(link)
    }
  }, [fontFamily])

  return null
}
